module.exports = __webpack_public_path__ + "images/icon/check_on-489d7bc8.svg";